class HolidayTypesService {

  constructor() {
    this.HOLIDAY = 'holiday';
    this.VACATION = 'vacation';
    this.ABSENCE = 'absence';
    this.APPROVED = 'approved';
    this.REQUESTED = 'requested';
  }

  getHoliday() {
    return this.HOLIDAY;
  }

  getVacation() {
    return this.VACATION;
  }

  getAbsence() {
    return this.ABSENCE;
  }

  getApproved() {
    return this.APPROVED;
  }

  getRequested() {
    return this.REQUESTED;
  }

}

export default HolidayTypesService;



// WEBPACK FOOTER //
// ./client/app/common/services/autoservicesDictionary.service.js